import { render, staticRenderFns } from "./investorsCards.vue?vue&type=template&id=cb3e6d3c&"
import script from "./investorsCards.vue?vue&type=script&lang=js&"
export * from "./investorsCards.vue?vue&type=script&lang=js&"
import style0 from "./investorsCards.vue?vue&type=style&index=0&id=cb3e6d3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports